import type { WidgetEffectParams } from '@swf/core/store';
import type { BasicSportsWidgetConfig } from '@swf/sports/pages/types';
import { sportsWidgetPollingBehavior } from '@swf/sports/utils/actions';
import buildSportsRequest from '@swf/sports/utils/buildSportsRequest';
import getErrorStatusCode from '@swf/sports/utils/getErrorStatusCode';
import { getWidgetCancellationSignal } from '@swf/sports/utils/getWidgetCancellationSignal';
import { hasRequestAborted } from '@swf/sports/utils/hasRequestAborted';

import type { AntePostMarketHandlerResponseBody, WidgetDispatch, WidgetSelect } from './types';

export const effects = {
  async preload(_payload: undefined, params: WidgetEffectParams<BasicSportsWidgetConfig>) {
    const { dispatch, widget, select, rootState } = params;
    const { antePostMarketRequested, clear }: WidgetDispatch = dispatch[widget.uid];
    const widgetSelect: WidgetSelect = select[widget.uid];

    sportsWidgetPollingBehavior(params).subscribe({
      next: (pollingSource) =>
        antePostMarketRequested({ isBackgroundLoading: pollingSource === 'INTERVAL' }),
      complete: clear
    });

    const hasPreloaded = widgetSelect.hasPreloaded(rootState);
    if (!hasPreloaded) {
      await antePostMarketRequested();
    }
  },
  async antePostMarketRequested(
    _payload: undefined,
    params: WidgetEffectParams<BasicSportsWidgetConfig>
  ): Promise<void> {
    const { dispatch, request, widget, select, rootState } = params;
    const widgetDispatch: WidgetDispatch = dispatch[widget.uid];
    const { marketId } = select.sports.getUrlParams(rootState);
    const sportsRequest = buildSportsRequest(request, rootState);
    try {
      const { body } = await sportsRequest<AntePostMarketHandlerResponseBody>({
        path: `/ante-post-market/${marketId}`,
        signal: getWidgetCancellationSignal(params)
      });
      widgetDispatch.dataLoadSuccess(body);
    } catch (error) {
      if (hasRequestAborted(error)) return;
      widgetDispatch.dataLoadFailed(getErrorStatusCode(error));
    }
  }
};
